function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FF4056",
  d: "M32.25 18.75c0 7.455-6.044 13.5-13.5 13.5s-13.5-6.045-13.5-13.5c0-7.456 6.044-13.5 13.5-13.5s13.5 6.044 13.5 13.5",
  opacity: 0.15
}), React.createElement("path", {
  fill: "#FF4056",
  d: "M37.5 18.75c0 10.355-8.395 18.75-18.75 18.75C8.394 37.5 0 29.105 0 18.75S8.394 0 18.75 0C29.105 0 37.5 8.395 37.5 18.75",
  opacity: 0.1
}), React.createElement("path", {
  fill: "#FF4056",
  d: "M27.75 18.75a9 9 0 1 1-18-.001 9 9 0 0 1 18 0"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M22.583 22.955a.527.527 0 0 1-.51-.137l-7.391-7.391a.527.527 0 0 1 .745-.745l7.391 7.391a.526.526 0 0 1-.235.882"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M15.19 22.955a.528.528 0 0 1-.509-.882l7.392-7.392a.527.527 0 1 1 .746.746l-7.393 7.392a.521.521 0 0 1-.235.136"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 38
  }, props), _ref);
};

export default SvgComponent;